/**
 * Расчёт задержек между попытками переподключения.
 *
 * Вынесен отдельно от транспорта намеренно: это чистая функция,
 * и проверять её можно без сокетов, таймеров и подмены времени.
 *
 * Джиттер обязателен. Browser Source перезапускается у всех
 * стримеров одновременно, когда падает наш сервер, — без разброса
 * они синхронно ударят в него снова через ровно ту же паузу,
 * и он ляжет второй раз.
 */
export const DEFAULT_BACKOFF = {
    baseMs: 500,
    factor: 2,
    // Полминуты — предел, после которого стример решит, что оверлей
    // умер, и полезет перезапускать Browser Source руками
    maxMs: 30_000,
    jitter: 0.5,
};
/**
 * Задержка перед попыткой номер `attempt` (нумерация с 1).
 *
 * @param random источник случайности; параметр нужен тестам,
 *   чтобы проверять границы диапазона, а не гадать по выборке
 */
export function delayFor(attempt, options = DEFAULT_BACKOFF, random = Math.random) {
    if (attempt < 1) {
        throw new RangeError(`номер попытки должен быть не меньше 1, получено ${attempt}`);
    }
    const { baseMs, factor, maxMs, jitter } = options;
    // Возведение в степень до умножения: при большом числе попыток
    // промежуточное значение уходит в Infinity, и Math.min спасает
    const raw = baseMs * factor ** (attempt - 1);
    const capped = Math.min(raw, maxMs);
    if (jitter <= 0)
        return capped;
    // Разброс вниз от расчётной величины: вверх уходить нельзя,
    // иначе потолок перестаёт быть потолком
    const spread = capped * Math.min(jitter, 1);
    return Math.round(capped - spread * random());
}
/**
 * Границы задержки для попытки — для тестов и для показа в панели.
 */
export function delayRange(attempt, options = DEFAULT_BACKOFF) {
    return {
        min: delayFor(attempt, options, () => 1),
        max: delayFor(attempt, options, () => 0),
    };
}
//# sourceMappingURL=backoff.js.map